import { useLocationTracking } from '@/hook/useLocation'
import { useCats } from '@/services/cats/hook'
// import { CatGender } from '@/type/cat'
import type { Cat } from '@/type/cat'
import { createContext } from 'react'

export type GlobalContextType = {
  location: google.maps.LatLngLiteral | undefined
  cats: {
    data: Cat[]
    pagination: {
      offset: number
      limit: number
      total: number
    }
  },
  mutate: () => void
}

export const GlobalContext = createContext<GlobalContextType | undefined>(
  undefined
)

export const GlobalProvider = ({ children }: { children: React.ReactNode }) => {
  const location = useLocationTracking()

  const { data: cats, isLoading, error, mutate } = useCats(1, 100);

  if (isLoading) {
    return <div>Loading...</div>
  }

  if (error) {
    return <div>Error: {error.message}</div>
  }


  // const cats: Cat[] = [
  //   {
  //     id: '1',
  //     name: 'Bob the cat',
  //     gender: CatGender.MALE,
  //     address: '8, 4 Soi Champee, ตำบลสุเทพ อำเภอเมืองเชียงใหม่ เชียงใหม่ 50200',
  //     lat: 18.793839723767892,
  //     lng: 98.96973690488839,
  //   },
  //   {
  //     id: '2',
  //     name: 'Smith the cat',
  //     gender: CatGender.MALE,
  //     address: '9 ซอย สายน้ำผึ้ง ตำบลสุเทพ อำเภอเมืองเชียงใหม่ เชียงใหม่ 50200',
  //     lat: 18.794330366186458,
  //     lng: 98.96941827332803,
  //   },
  //   {
  //     id: '3',
  //     name: 'Honey the cat',
  //     gender: CatGender.FEMALE,
  //     address: '8 Soi Jumpee, ตำบลสุเทพ อำเภอเมืองเชียงใหม่ เชียงใหม่ 50200',
  //     lat: 18.79378324709285,
  //     lng: 98.9699586548954,
  //   },
  // ]

  return (
    <GlobalContext.Provider value={{ location, cats, mutate }}>
      {children}
    </GlobalContext.Provider>
  )
}
